import React, { Component } from "react";
import "./CardComponent.scss";
import { materials, attackTypes, movementTypes, more } from "./emojis";

class CardComponent extends Component {
  // Methode zur Erzeugung der Fähigkeiten
  getAbilitys = (values) => {
    if (!values?.abilities) return null;

    return values.abilities.map((ability, i) => (
      <div key={`ability-${i}`}>
        <div>
          {ability.type && attackTypes[ability.type]}{" "}
          <b>
            {ability.name}
            {": "}
          </b>
          {ability.attack_value && ability.attack_value}
          {ability.range_cm &&
            `(${ability.range_cm[0]} - ${ability.range_cm[1]})`}
        </div>
        {ability.description && <div>{ability.description}</div>}
      </div>
    ));
  };

  // Methode zur Erzeugung des Titeltextes für den Header
  getCardHeaderTitle = () => {
    const { file, description, values, loading } = this.props.card;

    return !file
      ? "Bildupload bereit"
      : !description && loading
      ? "Analyse läuft..."
      : !description
      ? "Bildanalyse bereit"
      : !values && loading
      ? "Generierung läuft..."
      : !values
      ? "Generierung bereit"
      : values.name;
  };

  // Methode zur Erzeugung des Bewegungs-Strings
  getCardFooterMovement = () => {
    const { values } = this.props.card;
    return `${movementTypes[values?.movement_type] || ""} ${
      values?.movement_points || "-"
    }`;
  };

  // Methode zur Erzeugung des Material-Strings
  getCardFooterMaterial = () => {
    const { values } = this.props.card;
    return `
      ${materials[values?.material] || ""} 
      ${values?.defense_value || "-"}
      (${more["hit_points"] || ""} ${values?.hit_points || "-"})
    `;
  };

  // Methode zur Erzeugung des Bild-Inhalts
  getCardImageContent = () => {
    const { file } = this.props.card;
    return file ? (
      <img src={URL.createObjectURL(file)} alt="Karte" />
    ) : (
      <p>Kein Bild</p>
    );
  };

  // Methode zur Erzeugung des Beschreibungstextes
  getModalDescriptionContent = () => {
    const { values, description, loading } = this.props.card;
    return values ? 
        this.getAbilitys(values)
      : 
      description || ""
    ;

  //   <textarea
  //   id="description"
  //   className="description"
  //   disabled={!description || loading}
  //   name="description"
  //   placeholder="Keine Beschreibung verfügbar."
  //   defaultValue={description}
  //   onChange={this.props.handleDescriptionChange}
  // />
  };

  render() {
    const cardHeaderTitle = this.getCardHeaderTitle();
    const cardFooterMovement = this.getCardFooterMovement();
    const cardFooterMaterial = this.getCardFooterMaterial();
    const cardImageContent = this.getCardImageContent();
    const modalDescriptionContent = this.getModalDescriptionContent();

    return (
      <div className="card" {...this.props}>
        <div className="card-header">
          <h4>{cardHeaderTitle}</h4>
          <span className="summoning-cost">
            {this.props.card.values?.summoning_cost
              ? more["summoning_cost"] + this.props.card.values?.summoning_cost
              : "-"}
          </span>
        </div>

        <div className="card-body">
          <div className="card-image">
            {cardImageContent}
            <div className="card-model-size">
              {`
                ${this.props.card.values?.height_cm
                  ? more["height_cm"] + this.props.card.values?.height_cm
                  : "-"}
                ${this.props.card.values?.volume_cm3
                  ? more["volume_cm3"] + this.props.card.values?.volume_cm3
                  : "-"}
              `}
            </div>
          </div>
          <div className="card-description">
            {modalDescriptionContent}
            {this.props.card.error && <p className="error">{this.props.card.error}</p>}
          </div>
        </div>

        <div className="card-footer">
          <span className="footer-left">{cardFooterMovement}</span>
          <span className="footer-right">{cardFooterMaterial}</span>
        </div>
      </div>
    );
  }
}

export default CardComponent;
